__turbopack_context__.v({
  "clearBtn": "SearchInput-module-scss-module__VkqQuW__clearBtn",
  "flushBtn": "SearchInput-module-scss-module__VkqQuW__flushBtn",
  "input": "SearchInput-module-scss-module__VkqQuW__input",
  "root": "SearchInput-module-scss-module__VkqQuW__root",
  "searchIcon": "SearchInput-module-scss-module__VkqQuW__searchIcon",
});
